module.exports = __webpack_public_path__ + "img/ring_g_e_null_0.e023aa20.png";